import { Col, Flex, Row } from 'antd';
import { ErrorBox } from '~/app/components/common/Error/ErrorBox';
import { Loader } from '~/app/components/common/Loader/Loader';
import { ProgressStatCard } from '~/app/components/dashboard/ProgressStatCard/ProgressStatCard';
import { FailingSitesTableCard } from './components/FailingSitesTableCard/FailingSitesTableCard';
import { OperatorScoreCard } from './components/OperatorScoreCard/OperatorScoreCard';
import { ScorecardPageHeader } from './components/ScorecardPageHeader/ScorecardPageHeader';
import type { ScorecardPageViewProps } from './ScorecardPage.types';

export function ScorecardPageView(props: ScorecardPageViewProps) {
  const {
    isLoading,
    isError,
    errorTitle,
    errorMessage,
    pageTitle,
    subtitle,
    period,
    periodOptions,
    periodAriaLabel,
    generateReportLabel,
    summaryCards,
    operators,
    failingSitesTitle,
    failingSitesUrgentNote,
    failingSitesColumns,
    failingSitesRows,
    showingLabel,
    pageLabel,
    prevPageAriaLabel,
    nextPageAriaLabel,
    page,
    pageCount,
    onPageChange,
    onPeriodChange,
    onGenerateReport,
  } = props;

  if (isLoading && summaryCards.length === 0) {
    return <Loader />;
  }

  if (isError) {
    return <ErrorBox title={errorTitle} description={errorMessage} />;
  }

  if (summaryCards.length === 0) {
    return <Loader />;
  }

  return (
    <div className="app-page om-dashboard">
      <Flex vertical gap={24}>
        <ScorecardPageHeader
          title={pageTitle}
          subtitle={subtitle}
          period={period}
          periodOptions={periodOptions}
          periodAriaLabel={periodAriaLabel}
          generateReportLabel={generateReportLabel}
          onPeriodChange={onPeriodChange}
          onGenerateReport={onGenerateReport}
        />

        <Row gutter={[16, 16]}>
          {summaryCards.map((card) => (
            <Col key={card.id} xs={24} sm={12} xl={6}>
              <ProgressStatCard
                title={card.title}
                metric={card.metric}
                description={card.description}
                progressPercent={card.progressPercent}
              />
            </Col>
          ))}
        </Row>

        <Row gutter={[16, 16]} align="stretch">
          {operators.map((operator) => (
            <Col key={operator.id} xs={24} lg={8} style={{ display: 'flex' }}>
              <div style={{ width: '100%' }}>
                <OperatorScoreCard operator={operator} />
              </div>
            </Col>
          ))}
        </Row>

        <FailingSitesTableCard
          title={failingSitesTitle}
          urgentNote={failingSitesUrgentNote}
          columns={failingSitesColumns}
          rows={failingSitesRows}
          showingLabel={showingLabel}
          pageLabel={pageLabel}
          prevPageAriaLabel={prevPageAriaLabel}
          nextPageAriaLabel={nextPageAriaLabel}
          page={page}
          pageCount={pageCount}
          onPageChange={onPageChange}
        />
      </Flex>
    </div>
  );
}
